import { StyledBundlePrice } from './style';
import { Gradient, Prices } from 'utils/types';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';

export interface IBabaBundlePriceProps {
  bundleButtonColor?: Gradient;
  bundleButtonTextColor?: string;
  isFree?: boolean;
  collectText?: string;
  prices: Prices;
}

export const BabaBundlePrice: React.FC<IBabaBundlePriceProps> = ({
  prices,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
  isFree = false,
  collectText = '',
}) => {
  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
    >
      <div className="price-underlay">
        <div className="totalPrice">
          {isFree ? (
            <span>{collectText}</span>
          ) : (
            <ActualPrice
              prices={prices}
              textShadow="0px 2px 2px rgba(0, 0, 0, 0.25)"
            />
          )}
        </div>
      </div>
    </StyledBundlePrice>
  );
};
